// @flow

import React from 'react';
export function CartIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2.8C3 2.35817 3.35945 2 3.80286 2H5.00716C5.67227 2 6.21145 2.53726 6.21145 3.2V3.64844L16.2706 4.37454C16.9721 4.41822 17.4871 5.04864 17.3877 5.74191L16.6956 10.5697C16.6108 11.1609 16.1027 11.6 15.5034 11.6H6.21145V13.2H14.2458C15.576 13.2 16.6544 14.2745 16.6544 15.6C16.6544 16.9255 15.576 18 14.2458 18C12.9156 18 11.8372 16.9255 11.8372 15.6C11.8372 15.3195 11.8855 15.0502 11.9743 14.8H7.68012C7.76888 15.0502 7.81717 15.3195 7.81717 15.6C7.81717 16.9255 6.73881 18 5.40859 18C4.07836 18 3 16.9255 3 15.6C3 14.555 3.67024 13.666 4.60572 13.3366V4.40739C4.60569 4.40298 4.60569 4.39856 4.60572 4.39414V3.6H3.80286C3.35945 3.6 3 3.24183 3 2.8ZM13.4429 15.6C13.4429 15.1582 13.8024 14.8 14.2458 14.8C14.6892 14.8 15.0487 15.1582 15.0487 15.6C15.0487 16.0418 14.6892 16.4 14.2458 16.4C13.8024 16.4 13.4429 16.0418 13.4429 15.6ZM4.60572 15.6C4.60572 15.1582 4.96518 14.8 5.40859 14.8C5.852 14.8 6.21145 15.1582 6.21145 15.6C6.21145 16.0418 5.852 16.4 5.40859 16.4C4.96518 16.4 4.60572 16.0418 4.60572 15.6Z"
        fill="#5c5f62"
      />
    </svg>
  );
}
